// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect  } from "react";
import { useParams, useNavigate, useLocation,useOutletContext } from "react-router-dom";
import axios from "axios";
import PatientInfoForm from "../Forms/PatientInfoForm";
import CONFIG from '../../config';
//import AuthUtil from "../Mandali/AuthUtil";
import { useAuth } from "../../context/AuthProvider";
import { usePatient } from "../../context/PatientContext";



// EditStudent Component 
const AddPatientInfo = () => {
    const location = useLocation();

    // let { patientId, caseId, visitId } = useParams();

    //  console.log ('in AddPatientInfo :', visitId); 
//    const [selectedVisit, setSelectedVisit] = useState(null);
//    const [submissionState, setSubmissionState] = useState(null);
    const baseURL = CONFIG.BASE_URL;

    let navigate = useNavigate();
    //const [formValues, setFormValues] = useState({ Student_Name: '', Student_Email: '', Student_Roll_Number: '' })

    const { verifyTokenAndRedirect } = useAuth();
    const { token, doctorInfo, setDoctorInfo, patientData, setPatientData, selectedCase, setSelectedCase, selectedVisit, setSelectedVisit } = usePatient();
  //  const token = localStorage.getItem("authToken"); // or from context


    useEffect(() => {

        verifyTokenAndRedirect();
        setSelectedCase(1);
        setSelectedVisit(1);

    }, []);


    //     useEffect(() => {


    //         console.log('inside use effect for PATIENT_ID : ', selectedVisit)

    //         if (submissionState?.submitted && selectedVisit) {

    //             //            // add patient to database
    //             //            const newPatientInfo = addPatientDetails(selectedVisit)

    //             // get patient id and update in the selected visit object
    //             //            console.log('New patient info from the database: ', newPatientInfo);

    // //            const prevSelectedVisit = selectedVisit;

    //             console.log(selectedVisit[0].patientInfo[0].PATIENT_ID)

    //             if (selectedVisit[0].patientInfo[0].PATIENT_ID != 0) {

    //                 console.log(selectedVisit); // This will log the updated state
    //                 navigate("/visits/symptoms");
    //             }
    //         }

    //     }, [submissionState, selectedVisit]);



    //onSubmit handler 
    const onSubmitHandler = async (patientData) => {

        //alert("On Submit");

        console.log('patient data inside add new patient on submit handler:', patientData);

        //        setSubmissionState({ submitted: false });

        const updatedPatientData = { ...patientData, DOCTOR_ID: doctorInfo.MANDALI_ID, CLINIC_ID: doctorInfo.CLINIC_ID};

        setPatientData(updatedPatientData);

        // add patient to database
        const newPatientResponse = await addPatientDetails(updatedPatientData);

        const newPatientId = newPatientResponse[1].newPatientInfo.PATIENT_ID;

        if (newPatientId !== 0) {

            const newPatientData = {PATIENT_ID: newPatientId, ...updatedPatientData, ACTION_STATUS: "ADD_NEW_CASE", patientInfo:[{...updatedPatientData, PATIENT_ID: newPatientId}]}

//            const newPatientData = {...updatedPatientData, PATIENT_ID: newPatientId, ACTION_STATUS: "ADD_NEW_CASE"};

            console.log ('newpatientData in add patient info after adding new patient',newPatientData);

            setPatientData(newPatientData);

            if (location.pathname.startsWith("/addpatient")) {
              navigate("/addpatient/symptoms");
            } else {
              console.warn("Unknown route, no redirection");
            }
        }

        console.log(newPatientResponse);


        //        setSubmissionState({ submitted: true });


    };


    const addPatientDetails = async (patientData) => {
        try {

            console.log('patient data before addition to db', patientData);
            // const patientInfo = selectedVisit[0].patientInfo[0];

            //            const response = await axios.post(`${baseURL}/patients/addpatient`, patientData);

            const response = await axios.post(`${baseURL}/patients/addpatient`, patientData, {
                headers: {
                    Authorization: `Bearer ${token}`,        // 🔐 JWT Token
                    doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
                    clinicId: doctorInfo.CLINIC_ID,
                    roleId: doctorInfo.MANDALI_ROLE
                }
            });

            console.log('Response:', response.data);

            return response.data;
            // Handle success (e.g., show a success message)
        } catch (error) {
            console.error('Error updating patient details:', error.response ? error.response.data : error.message);
            // Handle error (e.g., show an error message)
        }
    };





    // Return student form 
    return (

        <div>
            {console.log('inside rendering: ', selectedVisit)}
            {(
                <PatientInfoForm
                    initialValues={selectedVisit}
                    onSubmit={onSubmitHandler}
                    enableReinitialize={true}
                >
                    Update Patient
                </PatientInfoForm>
            )}
        </div>
    );

};

// Export EditStudent Component 
export default AddPatientInfo;
